import { Flex, TextV2 } from '@withjoy/joykit';
import React from 'react';
import { useVIPList } from '../hooks/useVIPList';
import { VipCard } from './VipCard';
import { JsonDataContainerFragment } from '@graphql/generated';
import { applyPresentationSettings } from '@apps/guest/packages/layout-engine/widgets/WeddingPartyList';
import { useTranslation } from '@shared/core';

type VIPListProps = {
  vipList: ReturnType<typeof useVIPList>['data'];
  loading: boolean;
  onClickVip?: (id: string) => void;
  onDeleteClick?: (id: string) => void;
  presentationData: {
    sortOrder: string[];
    excludedIDs: string[];
  };
  handleFilterClick: (id: string, isExcluding: boolean) => void;
  handleReorder?: (id: string, direction: 'up' | 'down') => void;
  isFiltering: boolean;
  data: JsonDataContainerFragment;
};

export const VIPList = (props: VIPListProps) => {
  const { vipList, loading, presentationData, handleFilterClick, isFiltering, handleReorder } = props;
  const { tq } = useTranslation('VIPCustomComponent');

  if (loading) {
    return null;
  }

  const filteredVIPs = applyPresentationSettings(vipList ?? [], presentationData, isFiltering);

  if (filteredVIPs.length === 0) {
    return (
      <TextV2
        margin="auto"
        marginTop="2rem"
      >{tq`Add your first VIP to get started!`}</TextV2>
    );
  }

  return (
    <Flex
      flexDirection="column"
      gap="0.5rem"
      marginBottom="10rem"
    >
      {filteredVIPs.map(vip => {
        const isExcluded = presentationData.excludedIDs.includes(vip.id);

        return (
          <VipCard
            onClick={() => props.onClickVip?.(vip.id)}
            onDeleteClick={() => props.onDeleteClick?.(vip.id)}
            showFilterButton={isFiltering}
            isExcluded={isExcluded}
            onFilterClick={excluded => {
              handleFilterClick(vip.id, excluded);
            }}
            onReorder={direction => {
              if (handleReorder) {
                handleReorder(vip.id, direction);
              }
            }}
            key={vip.id}
            data={vip}
          />
        );
      })}
    </Flex>
  );
};
